import { useState, useEffect } from "react";


import empty_user from "../../empty_user.png";

function StReview(props)
{

    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");


    const changeView = () => {
        if(view == "line")  {setView("list");} else setView("line");
    }


    var persons = tab.length;


    if(view == "list")
    {
        return (
            <div className="item_info" onClick={changeView}>
              Umowy: {persons} -ukryj-

               <div className="quickPopup shadowx">
                     
                            {  tab.map(  (item, ix) => {

                                  
                                    return <div className="qitem">
                                       {item.dziecko.imie} {item.dziecko.nazwisko}, {item.umowa.numer}
                                    </div>

                            } ) }
                   
               </div>
              

            </div> 
        )
       
    }


    return (
        <div className="item_info" onClick={changeView}>
              Umowy: {persons} -pokaż-
        </div> 
    )
}


export default StReview;